module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/common/quote-from-info/quote-from-info.scss
// module id = ./web/modern/components/quote/common/quote-from-info/quote-from-info.scss
// module chunks = 0